/**
 * Navigation indicator that slides horizontally between nav items
 * Uses event delegation to handle hover on nested Alpine components
 *
 * Link highlighting is handled server-side (nav is a Swup container)
 * This component only handles the sliding indicator bar position
 */
export default () => ({
  left: 0,
  width: 0,
  visible: false,
  activeElement: null,

  init() {
    // Set initial position synchronously to avoid flicker on Swup re-init
    this.findActiveAndUpdate();

    // Event delegation for mouseenter on nav items
    this.$el.addEventListener(
      "mouseenter",
      (e) => {
        const li = e.target.closest("li[data-nav-item]");
        if (li) {
          this.updatePosition(li);
        }
      },
      true
    );

    // Event delegation for mouseleave - return to active
    this.$el.addEventListener(
      "mouseleave",
      (e) => {
        const li = e.target.closest("li[data-nav-item]");
        if (li) {
          const related = e.relatedTarget;
          const isLeavingNav =
            !related || !this.$el.contains(related) || related === this.$el;
          if (isLeavingNav) {
            this.updatePosition(this.activeElement);
          }
        }
      },
      true
    );

    // On click, immediately update activeElement so mouseleave doesn't snap back
    this.$el.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link) {
        const li = link.closest("li[data-nav-item]");
        if (li) {
          this.activeElement = li;
        }
      }
    });
  },

  findActiveAndUpdate() {
    // Find the nav item marked as active by the server
    this.activeElement = this.$el.querySelector("[data-nav-active]");
    this.updatePosition(this.activeElement);
  },

  updatePosition(element) {
    if (!element) {
      this.visible = false;
      return;
    }

    const rect = element.getBoundingClientRect();
    const parentRect = this.$el.getBoundingClientRect();

    this.left = rect.left - parentRect.left;
    this.width = rect.width;
    this.visible = true;
  },
});
